import React from 'react'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import { ICertification } from '../../../../../../context/types'
import { FormListFieldData } from 'antd/lib/form/FormList'

import './index.less'

const DragHandle = SortableHandle(() => <span className="sort-handle" />)

const SortableList = SortableContainer(({ children }: { children: React.ReactNode }) => {
	return <ul className="sort-list">{children}</ul>
})

const SortableItem = SortableElement(({ children }: { children: React.ReactNode }) => (
	<li className="sort-item">
		<DragHandle />
		{children}
	</li>
))

type TSortableCertifications = {
	fields: FormListFieldData[]
	remove: (index: number | number[]) => void
	form: FormInstance
}

const SortableCertifications = (props: TSortableCertifications) => {
	const { fields, remove, form } = props

	const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
		const values = form.getFieldsValue()
		const certifications = changeRank(values.certifications, oldIndex, newIndex)
		form.setFieldsValue({ ...values, certifications })
	}

	const changeRank = (array: ICertification[], from: number, to: number) => {
		const certificates = [...array]
		const endIndex = to < 0 ? array.length + to : to

		const [item] = certificates.splice(from, 1)
		certificates.splice(endIndex, 0, item)

		return certificates.map((certificate, index: number) => ({ ...certificate, rank: index }))
	}

	return (
		<SortableList onSortEnd={onSortEnd} useDragHandle>
			{fields.map(({ key, name, fieldKey, ...restField }: FormListFieldData, index: number) => (
				<SortableItem key={key} index={index}>
					<Row align="bottom" gutter={[8, 0]} className="sortable-content">
						<Col flex="auto">
							<Form.Item
								{...restField}
								label="Name"
								name={[name, 'name']}
								fieldKey={[fieldKey, 'name']}
								rules={[{ required: true, message: 'Missing name' }]}
							>
								<Input placeholder="Name" />
							</Form.Item>
						</Col>
						<Col flex="auto">
							<Form.Item
								{...restField}
								label="Issuing Organization"
								name={[name, 'issuing_organization']}
								fieldKey={[fieldKey, 'issuing_organization']}
								rules={[{ required: true, message: 'Missing issuing organization' }]}
							>
								<Input placeholder="Issuing Organization" />
							</Form.Item>
						</Col>
						<Col flex="none">
							<CloseCircleOutlined className="delete-btn" onClick={() => remove(name)} />
						</Col>
					</Row>
				</SortableItem>
			))}
		</SortableList>
	)
}

export default SortableCertifications
